import { combineReducers } from 'redux';
import { connectRouter } from 'connected-react-router';
import { featureFlagReducer } from '@surfline/web-common/dist/features';
import contests from './contests';
import homecam from './homecam';
import homepage from './homepage';
import status from './status';
import user from './user';
import browser from './browser';
import search from './search';
import swellEvents from './swellEvents';
import multiCam from './multiCam';

export default history =>
  combineReducers({
    router: connectRouter(history),
    contests,
    homepage,
    homecam,
    status,
    user,
    browser,
    flags: featureFlagReducer,
    search,
    swellEvents,
    multiCam,
  });
